<template>
  <section class="header-alert" v-if="content">
    <div class="container">
      <div class="d-flex justify-content-center align-items-center py-2">
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 12.375V8.625H3V12.375H1.5ZM3.75 12.75V7.875H9.375V13.125H3.75V12.75ZM7.875 20.25H5.25V13.875H7.875V20.25ZM18.75 16.7197L18.5602 16.53C17.4832 15.4471 16.2021 14.5886 14.7911 14.0042C13.3801 13.4197 11.8672 13.1209 10.3399 13.125H10.125V7.875H10.3399C11.8672 7.87913 13.3801 7.58031 14.7911 6.99585C16.2021 6.41138 17.4832 5.55287 18.5602 4.47L18.75 4.28025V16.7197Z" fill="white"/>
            <path d="M21.75 10.5C21.75 10.1022 21.592 9.72064 21.3107 9.43934C21.0294 9.15804 20.6478 9 20.25 9V9.75C20.4489 9.75 20.6397 9.82902 20.7803 9.96967C20.921 10.1103 21 10.3011 21 10.5C21 10.6989 20.921 10.8897 20.7803 11.0303C20.6397 11.171 20.4489 11.25 20.25 11.25V12C20.6478 12 21.0294 11.842 21.3107 11.5607C21.592 11.2794 21.75 10.8978 21.75 10.5Z" fill="white"/>
            <path d="M20.25 7.5V8.25C20.8467 8.25 21.419 8.48705 21.841 8.90901C22.2629 9.33097 22.5 9.90326 22.5 10.5C22.5 11.0967 22.2629 11.669 21.841 12.091C21.419 12.5129 20.8467 12.75 20.25 12.75V13.5C21.0456 13.5 21.8087 13.1839 22.3713 12.6213C22.9339 12.0587 23.25 11.2956 23.25 10.5C23.25 9.70435 22.9339 8.94129 22.3713 8.37868C21.8087 7.81607 21.0456 7.5 20.25 7.5Z" fill="white"/>
          </svg>
        </span>
        <div class="ms-3 pe-4 px-md-0">
          <div class="me-2 mb-0 text-center header-alert-text" v-html="content"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    content: HTMLElement
  }
}
</script>

<style scoped>

</style>
